module.exports = __webpack_public_path__ + "static/media/Payroll2.996d6517.svg";